module.exports = __webpack_public_path__ + "db0e1ad8efabf70d49d94ce3d0761d80.svg";